module.exports = {
    HallowsActivityEvent: "HallowsActivityEvent"//圣器激活事件
    , HallowsUpdateEvent: "HallowsUpdateEvent"//圣器更新时间
    , HallowsAdvanceEvent: "HallowsAdvanceEvent"//圣器进阶成功事件
    ,HallowsSkillUpgradeEvent: "HallowsSkillUpgradeEvent"//圣器技能升级
    ,HallowsEqupUpEvent: "HallowsEqupUpEvent"//圣灵穿戴事件
    ,HallowsRedStatus: "HallowsRedStatus"//神器红点
    ,UpdateHallowsTaskEvent: "UpdateHallowsTaskEvent"//圣器任务变化
    ,InitHallowsEvent: "InitHallowsEvent"//圣器
    ,UndateHallowsInfoEvent: "UndateHallowsInfoEvent"//显示某个神器


    ,CloseTaskEffectEvent:"CloseTaskEffectEvent"    //关闭带有神器任务引导的手指特效界面
}